/* Stateful component that switches from the Default reply options DD, to the
 * Snooze DD. They share the same trigger to appear seamless
 * */
import React from 'react'
import PropTypes from 'prop-types'

import { isEdge } from 'util/browser'

import SnoozeDropdown from 'components/App/DesktopView/shared/Snooze'
import CommentingDropdown from './CommentingDropdown'

/**
 * Serg: The code is morally wrong and disgusting but doing it properly will
 * take time and we need to ship this now. If you still see this in 3 months
 * (i.e. after March 2019), feel free to curse and shame me (and Jared for the copy-pasta).
 */

class DropdownSwitcher extends React.Component {
  state = { snoozeMenuVisible: false }

  showSnoozeMenu = () => {
    this.setState({ snoozeMenuVisible: true })
  }

  closeSnoozeMenu = () => {
    this.setState({ snoozeMenuVisible: false })
  }

  handleOnSnoozeOptionClick = (snoozeUntil, evt) => {
    const { onSnoozeOptionClick } = this.props
    if (onSnoozeOptionClick) onSnoozeOptionClick(snoozeUntil, evt)
    this.closeSnoozeMenu()
  }

  render() {
    const {
      className,
      disabled,
      isOpen,
      onSendClosedClick,
      onSendOpenClick,
      onFocus,
    } = this.props

    const commonProps = {
      className,
      disabled,
      button: true,
      floating: true,
      trigger: <div />, // https://github.com/Semantic-Org/Semantic-UI-React/issues/1717
      upward: true,
      onFocus,
    }
    const { snoozeMenuVisible } = this.state

    if (snoozeMenuVisible) {
      return (
        <SnoozeDropdown
          {...commonProps}
          open
          spoofDropdownButton
          iconTrigger={false}
          suiWrap={false}
          onOptionClick={this.handleOnSnoozeOptionClick}
          onClose={this.closeSnoozeMenu}
          customSnoozeModalDirection="left"
          snoozeButtonLabel="Add note & snooze"
          closeOnBlur={
            // For some reason, click event in Edge takes longer to bubble
            // than in other browsers, so with "close on blur" enabled
            // dropdown automatically closes as soon as it is opened by user.
            // To fix this, we are not closing this dropdown on blur in Edge,
            // which isn't ideal, but tolerable UX.
            !isEdge()
          }
        />
      )
    }

    return (
      <CommentingDropdown
        {...commonProps}
        isOpen={isOpen}
        onSendOpenClick={onSendOpenClick}
        onSendClosedClick={onSendClosedClick}
        onSendSnoozedClick={this.showSnoozeMenu}
      />
    )
  }
}

DropdownSwitcher.propTypes = {
  /* Whether the dropdown menu is disabled */
  disabled: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  /* onClick handlers for the button + each of the 3 DD menu options */
  onSendOpenClick: PropTypes.func.isRequired,
  onSendClosedClick: PropTypes.func.isRequired,
  /* onClick handler for snooze menu options */
  onSnoozeOptionClick: PropTypes.func.isRequired,
}

DropdownSwitcher.defaultProps = {
  disabled: false,
}

export default DropdownSwitcher
